import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { unformat } from 'accounting';
import * as classNames from 'classnames';
import { IAppOnlyStore } from '../../../stores/AllStores';
import { OrderItem, OrderItemsGroups } from '../../../components/item/index';
import { ICartItem } from '../../../../../common/interfaces/search';
import { Button, EButtonType } from '../../../components/action';

// Styles
const s = require('./PortalCheckoutYearsSelection.css');

// Component
@inject('store')
@observer
export class PortalCheckoutYearsSelection extends React.Component<IAppOnlyStore, {}> {
    render() {
        const { checkout } = this.props.store;

        return (
            <div>
                {this.props.store.cart.currentCart && (
                    <OrderItemsGroups
                        items={this.props.store.cart.currentCart.item.filter(item => item.quantity > 0)}
                        requireYearsSelection={true}
                        onSelectedYearChange={this.handleSelectedYearChange}
                        selectedYears={checkout.cartItemsSelectedYears.reduce((selectedYears, group) => {
                            return {
                                ...selectedYears,
                                [group.groupConcat]: {
                                  year: group.year,
                                  vin: group.vin
                                }
                            };
                        }, {})}
                    />
                )}

                <div className={s.submit}>
                    {!checkout.cartItemsAllHaveCorrectVin ? (
                      <Button
                        inBox={true}
                        type={EButtonType.BorderOnly}
                    >
                        {'At least one VIN is incorrect'}
                    </Button>
                    ) : null}
                    <Button
                        inBox={true}
                        onClick={!checkout.cartItemsAllHaveCorrectVin ? null : this.handleMoveFromYearSelectionToTerms}
                        type={
                          checkout.cartItemsAllHaveYearSelected
                          ? !checkout.cartItemsAllHaveCorrectVin
                          ? EButtonType.Default
                          : EButtonType.Action
                          : EButtonType.BorderOnly
                        }
                    >
                        {checkout.cartItemsAllHaveYearSelected
                            ? 'Proceed'
                            : 'All parts are required to have year of the vehicle selected'}
                    </Button>
                </div>
            </div>
        );
    }

    private handleSelectedYearChange = (
      groupConcat: string,
      itemIds: number[],
      selectedYear: number | null,
      vin: string | null
      ) => {
        this.props.store.checkout.changeSelectedYears(groupConcat, itemIds, selectedYear, vin);
    };

    private handleMoveFromYearSelectionToTerms = () => {
      const {checkout} = this.props.store;

      if (!checkout.cartItemsAllHaveYearSelected) {
        return;
      } else {
        if (!checkout.cartItemsAllHaveVin) {
          checkout.moveToVINMissing();
          return;
        }
        checkout.moveToTerms();
      }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutYearsSelection.tsx